import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MapPin, Phone } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-slate-900 relative" data-id="element-1108">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1109">
        <div className="max-w-5xl mx-auto bg-slate-800/50 rounded-3xl border border-slate-700 overflow-hidden flex flex-col md:flex-row" data-id="element-1110">
          {/* Contact Info */}
          <div className="md:w-2/5 bg-gradient-to-br from-fox-600 to-fox-800 p-10 text-white relative overflow-hidden" data-id="element-1111">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-1112" />

            <h3 className="text-3xl font-heading font-bold mb-2 relative z-10" data-id="element-1113">
              Get in touch
            </h3>
            <p className="text-fox-100 mb-10 relative z-10" data-id="element-1114">
              We'd love to hear from you. Our friendly team is always here to
              chat.
            </p>

            <div className="space-y-6 relative z-10" data-id="element-1115">
              <div className="flex items-center gap-4" data-id="element-1116">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center shrink-0" data-id="element-1117">
                  <Mail size={20} data-id="element-1118" />
                </div>
                <div data-id="element-1119">
                  <p className="text-sm text-fox-200" data-id="element-1120">Email us</p>
                  <p className="font-medium" data-id="element-1121">support@foxlinehosting.com</p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-1122">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center shrink-0" data-id="element-1123">
                  <Phone size={20} data-id="element-1124" />
                </div>
                <div data-id="element-1125">
                  <p className="text-sm text-fox-200" data-id="element-1126">Call us</p>
                  <p className="font-medium" data-id="element-1127">+1 (555) 123-4567</p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-1128">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center shrink-0" data-id="element-1129">
                  <MapPin size={20} data-id="element-1130" />
                </div>
                <div data-id="element-1131">
                  <p className="text-sm text-fox-200" data-id="element-1132">Office</p>
                  <p className="font-medium" data-id="element-1133">
                    123 Fox Den Way
                    <br data-id="element-1134" />
                    Forest City, FC 90210
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="md:w-3/5 p-10 bg-slate-900" data-id="element-1135">
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-1136">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1137">
                <div className="space-y-2" data-id="element-1138">
                  <label className="text-sm font-medium text-slate-300" data-id="element-1139">
                    First Name
                  </label>
                  <input type="text" className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-fox-500 focus:ring-1 focus:ring-fox-500 transition-colors" placeholder="John" data-id="element-1140" />
                </div>
                <div className="space-y-2" data-id="element-1141">
                  <label className="text-sm font-medium text-slate-300" data-id="element-1142">
                    Last Name
                  </label>
                  <input type="text" className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-fox-500 focus:ring-1 focus:ring-fox-500 transition-colors" placeholder="Doe" data-id="element-1143" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-1144">
                <label className="text-sm font-medium text-slate-300" data-id="element-1145">
                  Email
                </label>
                <input type="email" className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-fox-500 focus:ring-1 focus:ring-fox-500 transition-colors" placeholder="john@example.com" data-id="element-1146" />
              </div>

              <div className="space-y-2" data-id="element-1147">
                <label className="text-sm font-medium text-slate-300" data-id="element-1148">
                  Message
                </label>
                <textarea rows={4} className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-fox-500 focus:ring-1 focus:ring-fox-500 transition-colors resize-none" placeholder="How can we help you?" data-id="element-1149"></textarea>
              </div>

              <button className="w-full bg-fox-600 hover:bg-fox-500 text-white font-medium py-3 rounded-lg transition-colors" data-id="element-1150">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}